import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTracking } from 'react-tracking'

import Tooltip2 from 'components/common/Tooltip2.0'
import useLocalVideoToggle from 'hooks/useLocalVideoToggle/useLocalVideoToggle'
import { dispatchUpdateParticipantInfo } from 'store/dispatcher/Room'
import { _userId } from 'store/selectors/User'
import { logger } from 'utils/logger'

import { BtnWrapper, Button, MenuIcon } from '../styles'

const ICON_BASE = '/assets/revamp'

const ToggleVideoButton = props => {
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle()
    const userId = useSelector(_userId)

    const tracking = useTracking()

    const [blockVideoTimerAnim, setBlockVideoTimerAnim] = useState(false)
    useEffect(() => {
        blockVideoTimerAnim &&
            setTimeout(() => setBlockVideoTimerAnim(false), 2000)
    }, [blockVideoTimerAnim])

    useEffect(() => {
        dispatchUpdateParticipantInfo(userId, 'isVideoEnabled', isVideoEnabled)
        tracking &&
            tracking.trackEvent({
                action: isVideoEnabled ? 'video_on' : 'video_off',
            })
        logger.info(`user video status : ${isVideoEnabled ? 'on' : 'off'}`)
    }, [isVideoEnabled, tracking])

    const menuSrc = isVideoEnabled
        ? `${ICON_BASE}/camera-on.svg`
        : `${ICON_BASE}/camera-off.svg`

    console.count('ToggleVideoButton Component')

    const btnProps = {
        onClick: () => {
            if (blockVideoTimerAnim) return
            toggleVideoEnabled()
            setBlockVideoTimerAnim(true)
        },
        disabled: props.disabled,
        'data-cy-audio-toggle': true,
        clicked: !isVideoEnabled,
        isMobile: false,
    }

    return (
        <Tooltip2
            content={isVideoEnabled ? 'disable video' : 'enable video'}
            placement="top"
        >
            <BtnWrapper disabled={blockVideoTimerAnim}>
                <Button {...btnProps}>
                    <MenuIcon
                        clicked={!isVideoEnabled}
                        src={menuSrc}
                        alt="video-menu"
                    />
                </Button>
            </BtnWrapper>
        </Tooltip2>
    )
}

export { ToggleVideoButton }
